import './Sso.scss'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import { selectClubOneTab } from '../../actions/actions'
import { getCompany, isClubOneLogged, isCompanyCustomerLogged, isCompanyTabSelected } from '../../selectors/selectors'
import CompanyCustomer from '../Summary/CustomerLogin/CompanyCustomer/CompanyCustomer'
import MobileClubOneLoggedIn from './MobileClubOneLoggedIn/MobileClubOneLoggedIn'
import MobileClubOneLogin from './MobileClubOneLogin/MobileClubOneLogin'

export default function Sso() {
  const companyTabSelected = useSelector(isCompanyTabSelected)
  const companyCustomerLogged = useSelector(isCompanyCustomerLogged)
  const { companyIdFieldValue } = useSelector(getCompany)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (companyTabSelected && companyIdFieldValue) history.push('/companyCustomer')
    else dispatch(selectClubOneTab())
  }, [dispatch, companyTabSelected, companyIdFieldValue, history])

  return <div className="sso">{companyCustomerLogged ? <CompanyCustomer /> : <ClubOne />}</div>
}

function ClubOne() {
  const clubOneLogged = useSelector(isClubOneLogged)

  return clubOneLogged ? <MobileClubOneLoggedIn /> : <MobileClubOneLogin />
}
